<template>
  <van-nav-bar
    title="可选课程"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
    fixed
    placeholder
  />

  <!-- 星期 Tab 栏 -->
  <div class="week-tab-bar">
    <div
      v-for="tab in weekTabs"
      :key="tab.value"
      class="week-tab-item"
      :class="{ active: activeWeek === tab.value }"
      @click="onTabChange(tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>

  <!-- 加载中 -->
  <div v-if="loading" class="loading-wrap">
    <van-loading color="#52C1B2" size="32px" vertical>加载中...</van-loading>
  </div>

  <!-- 课程列表 -->
  <div v-if="!loading && courseList.length > 0" class="course-container">
    <div class="course-list">
      <div
        v-for="course in courseList"
        :key="course.id"
        class="course-item"
        :class="'type-' + course.course_type"
        @click="toDetail(course)"
      >
        <!-- 时间 + 类型标签 -->
        <div class="course-time-row">
          <span class="course-time">{{ course.serviceTime }}</span>
          <!-- <span
            class="course-type-tag"
            :class="
              course.course_type == 1
                ? 'type-bg-' + course.course_type
                : 'type-bg-' + course.course_type
            "
          >
            {{ course.typeLabel }}
          </span> -->
        </div>

        <!-- 课程名 -->
        <div class="course-main-row">
          <span class="course-name">{{ course.name }}</span>
        </div>

        <!-- 价格 + 报名状态 -->
        <div class="course-meta-row">
          <span class="course-price" v-if="course.course_type == 1">
            材料费: ¥{{ course.cost }}元<template v-if="course.cost != '0.00'">
            </template>
          </span>
          <!-- <span class="course-price free" v-else
            >课时费: ¥{{ course.hour_cost }}元 /{{
              course.class_hour ? course.class_hour + "课时" : "课时"
            }}
          </span> -->
          <span class="course-price free" v-else>
            课时费: ¥{{ course.hour_cost }}元{{
              Number(course.hour_cost) > 0
                ? " /" + (course.class_hour ? course.class_hour + "课时" : "课时")
                : ""
            }}
          </span>
          <span
            class="registration-tag"
            :class="course.isRegistration ? 'registered' : 'unregistered'"
          >
            {{ course.isRegistration ? "已报名" : "未报名" }}
          </span>
        </div>

        <!-- 右箭头 -->
        <span class="course-arrow">›</span>
      </div>
    </div>
  </div>

  <!-- 空状态 -->
  <div v-if="!loading && courseList.length === 0" class="empty-wrap">
    <van-empty description="暂无可报名的课程" />
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";
import { getAreaType } from "../common/js/utils";

const COURSE_TYPE_MAP = {
  1: "校外专业导师课",
  2: "校内课",
  3: "特色课",
  4: "其他课",
};

const WEEK_TABS = [
  { label: "周一", value: "星期一" },
  { label: "周二", value: "星期二" },
  { label: "周三", value: "星期三" },
  { label: "周四", value: "星期四" },
  { label: "周五", value: "星期五" },
  { label: "周六", value: "星期六" },
  { label: "周日", value: "星期日" },
];

export default {
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const courseList = ref([]);
    const WEEK_STORAGE_KEY = "allCourses_activeWeek";
    const activeWeek = ref(sessionStorage.getItem(WEEK_STORAGE_KEY) || "星期一");

    function onTabChange(week) {
      activeWeek.value = week;
      sessionStorage.setItem(WEEK_STORAGE_KEY, week);
      loadCourses();
    }

    async function loadCourses() {
      loading.value = true;
      try {
        const res = await api.getEnrollmentSettings({
          student_id: sessionStorage.getItem("childId"),
          type: getAreaType(),
          week: activeWeek.value,
        });

        if (res.data.code == 1001) {
          const apiData = res.data.result || [];
          courseList.value = apiData.map((item) => ({
            id: item.id,
            course_type: item.course_type,
            typeLabel:
              item.course_type === 1
                ? item.cost && item.cost != "0.00"
                  ? "校外专业导师课"
                  : "校外专业导师课"
                : COURSE_TYPE_MAP[item.course_type] || "其他",
            name: item.title,
            cost: item.cost || "0.00",
            hour_cost: item.hour_cost || "0.00",
            class_hour: item.class_hour,
            serviceTime: item.service_time || "",
            signUp: item.sign_up || 0,
            isRegistration: item.is_registration == 1,
            enrollment_settings_id: item.id,
          }));
        } else {
          Toast(res.data.message || "获取失败");
          courseList.value = [];
        }
      } catch {
        Toast("请求失败");
        courseList.value = [];
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => {
      loadCourses();
    });

    const toDetail = (item) => {
      router.push({
        path: "/detail",
        query: { enrollment_id: item.id },
      });
    };

    const onClickLeft = () => router.go(-1);

    return {
      loading,
      courseList,
      activeWeek,
      weekTabs: WEEK_TABS,
      onTabChange,
      toDetail,
      onClickLeft,
    };
  },
};
</script>

<style lang="less" scoped>
/* ========== 星期 Tab 栏 ========== */
.week-tab-bar {
  display: flex;
  background-color: #fff;
  padding: 8px 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.week-tab-item {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: 13px;
  color: #666;
  border-radius: 20px;
  transition: all 0.2s;
  cursor: pointer;

  &.active {
    background-color: var(--color-primary);
    color: #fff;
    font-weight: bold;
  }

  &:active {
    opacity: 0.8;
  }
}

/* ========== 加载 / 空状态 ========== */
.loading-wrap {
  display: flex;
  justify-content: center;
  padding-top: 80px;
}

.empty-wrap {
  padding-top: 80px;
}

/* ========== 课程列表容器 ========== */
.course-container {
  background-color: #f5f5f5;
  min-height: calc(100vh - 100px);
  padding: 16px 16px 40px;
}

.course-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ========== 课程卡片 ========== */
.course-item {
  position: relative;
  padding: 16px 40px 16px 18px;
  background-color: #fff;
  border-radius: 12px;
  border-left: 5px solid var(--color-primary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;

  &:active {
    opacity: 0.85;
  }

  &.type-1 {
    border-left-color: #ff6b6b;
  }
  &.type-2 {
    border-left-color: #4ecdc4;
  }
  &.type-3 {
    border-left-color: #f7b731;
  }
  &.type-4 {
    border-left-color: #a29bfe;
  }
}

.course-time-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  .course-time {
    font-size: 13px;
    color: var(--color-primary);
    font-weight: bold;
  }

  .course-type-tag {
    margin-left: auto;
  }
}

.course-type-tag {
  flex-shrink: 0;
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 12px;

  &.type-bg-1 {
    background-color: #fff7e6;
    color: #ff8800;
  }
  &.type-bg-1-free {
    background-color: #e6fffb;
    color: #52c1b2;
  }
  &.type-bg-2 {
    background-color: #e6fffb;
    color: #52c1b2;
  }
  &.type-bg-3 {
    background-color: #f9f0ff;
    color: #7232dd;
  }
  &.type-bg-4 {
    background-color: #f5f5f5;
    color: #666;
  }
}

.course-main-row {
  margin-bottom: 8px;

  .course-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.course-meta-row {
  display: flex;
  align-items: center;
  gap: 8px;

  .course-price {
    font-size: 14px;
    color: #ff6b35;
    font-weight: 600;

    &.free {
      color: #07c160;
    }
  }

  .registration-tag {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    flex-shrink: 0;
    margin-left: auto;

    &.registered {
      color: #07c160;
      background-color: #e8f8ef;
    }

    &.unregistered {
      color: #999;
      background-color: #f5f5f5;
    }
  }
}

.course-arrow {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  color: #ccc;
  font-weight: bold;
  line-height: 1;
}

/* ========== 图例 ========== */
.course-legend {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
  gap: 14px;

  .legend-item {
    display: flex;
    align-items: center;
  }

  .legend-color {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 5px;
    display: inline-block;

    &.type-bg-1 {
      background-color: #ff6b6b;
    }
    &.type-bg-2 {
      background-color: #4ecdc4;
    }
    &.type-bg-3 {
      background-color: #f7b731;
    }
    &.type-bg-4 {
      background-color: #a29bfe;
    }
  }

  .legend-text {
    font-size: 12px;
    color: #666;
  }
}
</style>
